import Box from '@amzn/meridian/box';
import Row from '@amzn/meridian/row';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TooltipPositionsEnum } from '../../constants/meridian';
import InfoComponent from '../commons/InfoComponent';

const ManageUsersButton = ({ hasAdminRights }) => (
  <Box>
    <Row alignmentHorizontal="justify">
      <Row minWidth="70%">
        <FormattedMessage id="top_bar.settings_menu.manage_users" />
      </Row>
      <InfoComponent
        disabled={hasAdminRights}
        messageId="no_permissions"
        position={TooltipPositionsEnum.bottom}
      />
    </Row>
  </Box>
);

export default ManageUsersButton;
